// extracted by mini-css-extract-plugin
export default {"testimonial":"TestimonialOne_testimonial__bp5aS","thumb":"TestimonialOne_thumb__KYpRs","clientInfo":"TestimonialOne_clientInfo__J3KYv"};